import { Route } from 'react-router-dom';
import { fournisseurSchema } from './fournisseur';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module Fournisseur
 */
const FournisseurRoutes = [
    // Route de liste (principale)
    <Route
        key="fournisseurs-list"
        path="fournisseurs"
        element={
            <Main key="fournisseurs-main" pageConfig={fournisseurSchema} />
        }
    />,
];

export default FournisseurRoutes;
